import { mockData } from "./Mock";
import { EnterpriseVerifyApply } from "../../models/EnterpriseAudit";

const mockCandidates: EnterpriseVerifyApply[] = [
    {
        id: 1,
        licenseImageUrl: "https://via.placeholder.com/300x200/4CAF50/FFFFFF?text=营业执照1",
        companyName: "北京科技有限公司",
        taxNo: "91110000123456789X",
        telNo: "13800138001",
        companyAddress: "北京市朝阳区建国路88号",
        companyTelno: "010-12345678",
        bankName: "中国工商银行北京分行",
        bankCardNo: "6222021234567890123",
        companyEmail: "contact@beijingtech.com",
        buyerId: 1001,
        buyerNickname: "张三",
        buyerPhone: "13800138001",
        submitTime: "2024-03-15 10:30:00",
        status: 0
    },
    {
        id: 2,
        licenseImageUrl: "https://via.placeholder.com/300x200/2196F3/FFFFFF?text=营业执照2",
        companyName: "上海贸易有限公司",
        taxNo: "91310000123456789Y",
        telNo: "13900139002",
        companyAddress: "上海市浦东新区陆家嘴金融区",
        companyTelno: "021-87654321",
        bankName: "中国建设银行上海分行",
        bankCardNo: "6227001234567890123",
        companyEmail: "info@shanghaitrade.com",
        buyerId: 1002,
        buyerNickname: "李四",
        buyerPhone: "13900139002",
        submitTime: "2024-03-14 15:20:00",
        status: 0
    },
    {
        id: 3,
        licenseImageUrl: "https://via.placeholder.com/300x200/FF9800/FFFFFF?text=营业执照3",
        companyName: "深圳电子有限公司",
        taxNo: "91440300123456789Z",
        telNo: "13700137003",
        companyAddress: "深圳市南山区科技园",
        companyTelno: "0755-12345678",
        bankName: "招商银行深圳分行",
        bankCardNo: "6225881234567890123",
        companyEmail: "service@shenzhen.com",
        buyerId: 1003,
        buyerNickname: "王五",
        buyerPhone: "13700137003",
        submitTime: "2024-03-13 09:15:00",
        status: 0
    }
];

const mockProcessed: EnterpriseVerifyApply[] = [
    {
        id: 4,
        licenseImageUrl: "https://via.placeholder.com/300x200/4CAF50/FFFFFF?text=营业执照4",
        companyName: "广州制造有限公司",
        taxNo: "91440100123456789A",
        telNo: "13600136004",
        companyAddress: "广州市天河区珠江新城",
        companyTelno: "020-12345678",
        bankName: "中国农业银行广州分行",
        bankCardNo: "6228481234567890123",
        companyEmail: "hr@guangzhou.com",
        buyerId: 1004,
        buyerNickname: "赵六",
        buyerPhone: "13600136004",
        submitTime: "2024-03-10 14:30:00",
        status: 1,
        auditTime: "2024-03-12 10:00:00",
        auditorId: 2001,
        auditorName: "审核员A"
    },
    {
        id: 5,
        licenseImageUrl: "https://via.placeholder.com/300x200/F44336/FFFFFF?text=营业执照5",
        companyName: "杭州网络科技有限公司",
        taxNo: "91330100123456789B",
        telNo: "13500135005",
        companyAddress: "杭州市西湖区文三路",
        companyTelno: "0571-12345678",
        bankName: "中国银行杭州分行",
        bankCardNo: "6013821234567890123",
        companyEmail: "support@hangzhou.com",
        buyerId: 1005,
        buyerNickname: "孙七",
        buyerPhone: "13500135005",
        submitTime: "2024-03-08 11:45:00",
        status: 2,
        refuseReason: "营业执照信息不清晰，请重新上传",
        auditTime: "2024-03-09 16:20:00",
        auditorId: 2002,
        auditorName: "审核员B"
    }
];

mockData.set("enterprise_candidates", mockCandidates);
mockData.set("enterprise_processed", mockProcessed); 